import React, { useLayoutEffect } from 'react';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import { AppView, IconClose, rem, SCROLL_INDICATOR_INSETS, Spacer, StatusBar, withAnimatedNavigationHeader, } from 'design-system';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import Text from 'design-system/Text';
import IconCheck from 'design-system/icons/IconCheck';
import { useMarginBottom } from 'hooks/useMarginBottom';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { isIOS } from '../../../constants';
const strings = {
    title: 'How does the reference detection work?',
    shortTitle: 'Reference detection',
    subtitle: 'We detect transactions using the reference. What you input must be a substring of the references we are going to match. The detection is case insensitive, but spaces matter. See the examples below.',
};
const detectedArr = [
    'Emma Finance',
    'UK Emma Finance 200',
    'Emma Finance-100',
    'emma finance',
    'EMMA FINANCE',
];
const notDetectedArr = [
    'EmmaFinance',
    'Emma',
    'finance',
    'Emma in Finance',
    'Emma Technologies',
];
const SmartRuleReferenceInfoScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    useLayoutEffect(() => {
        navigation.setOptions({
            ...(isIOS && {
                headerLeft: () => (<NavigationCloseButton onPress={() => navigation.pop()}/>),
            }),
        });
    }, []);
    const { paddingHorizontalStyle } = useAppFrameDimensions(false, true);
    const contentContainerStyle = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    const styles = useStyles(styleSet);
    const colors = useColors();
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={contentContainerStyle}>
            <ScreenInfoHeader title={strings.title} subTitle={<>
                  <Spacer h={4}/>
                  <Text TextThin-16 Secondary>
                    {strings.subtitle}
                  </Text>
                </>}/>
            <Text TextThin-16 Secondary style={[styles.container, styles.text]}>
              If you set the reference &quot;
              <Text Text-16>Emma Finance</Text>
              &quot;, we will detect:
            </Text>
            <View style={[styles.container, styles.cardContainer]}>
              {detectedArr.map((item) => (<View key={item} style={styles.card}>
                  <IconCheck thick width={20} height={20} color={colors.elements.positive}/>
                  <Text Text-16>{item}</Text>
                </View>))}
            </View>
            <Text TextThin-16 Secondary style={[styles.container, styles.notDetectText]}>
              We will NOT detect:
            </Text>
            <View style={[styles.container, styles.cardContainer]}>
              {notDetectedArr.map((item) => (<View key={item} style={styles.card}>
                  <IconClose alt size={20} color={colors.elements.negative}/>
                  <Text Text-16>{item}</Text>
                </View>))}
            </View>
          </Animated.ScrollView>
        </AppView>);
}, ({ colors }) => ({
    title: strings.shortTitle,
    hideTitleOnScroll: true,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
    isIOS13NativeModal: true,
}));
const styleSet = createStyleSheets((colors) => ({
    container: {
        marginHorizontal: rem(16),
    },
    cardContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: rem(8),
    },
    card: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(8),
        backgroundColor: colors.cards.onDark,
        borderRadius: rem(12),
        paddingVertical: rem(8),
        paddingHorizontal: rem(12),
    },
    text: {
        marginVertical: rem(8),
    },
    notDetectText: {
        marginTop: rem(16),
        marginBottom: rem(12),
    },
}));
export default SmartRuleReferenceInfoScreen;
